module.exports = __webpack_public_path__ + "img/R_PLA.ae9cbf62.svg";